// extracted by mini-css-extract-plugin
export var formContainer = "_js-0";
export var message = "_js-1";